/*
 *
 *  * NOTICE OF LICENSE
 *  *
 *  * This source file is subject to the Academic Free License (AFL 3.0)
 *  *
 *  *  @author    Afternet <info@afternet.gr>
 *  *  @copyright 2022 Afternet
 *  *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 *
 */
import React, {useEffect, useState} from 'react';
//import {ReactComponent as Logo} from "../assets/img/logo.svg";
//import LogoPng from "../assets/img/AutoRec-logo-BETA-2x.png";
//import LogoPng from "../assets/img/AutoRec-Logo.png";
import LanguageSelect from "../components/LanguageSelect";
import {ReactComponent as LogIn} from "../assets/img/icons/login.svg";
import {ReactComponent as LogInBlack} from "../assets/img/icons/login-black.svg";
//import {ReactComponent as Search} from "../assets/img/icons/search.svg";
import {ReactComponent as LogoR} from "../assets/img/icons/autoreckparts.svg";
import {ReactComponent as Menu} from "../assets/img/icons/menu.svg";
import {Link, NavLink, useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "../Hooks/useAuth";
import {useTranslation} from "react-i18next";

const Header = () => {

    const [openSearch, setOpenSearch] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const user = useAuth();
    let navigate = useNavigate();
    const {pathname} = useLocation();
    const { t, i18n } = useTranslation();

    function hundleSearchBox (){
        setOpenSearch(!openSearch);
    }

    const submitSearch = () =>{
        navigate({
            pathname: 'cars/search',
            search: '?make_id=2&model=100',
        });
    }
    const logout = () =>{
        user.logOut();
    }
    const toggleMenu = () =>{
        setOpenMenu(v => !v);
    }

    useEffect(() => {
        setOpenMenu(false); // Close the navigation panel
    }, [ pathname ]);

    return (
        <header className='header'>
            <div className='container'>
                <div className='row align-items-center small-gutters'>
                    <div className='col-auto header__logo'>
                        {/*<Link to="/"><Logo/></Link>*/}
                        <Link to={`/${i18n.language}/`}>
                            <LogoR/>
                            {/*<img src={LogoPng} alt='AutoRec'/>*/}
                        </Link>
                    </div>
                    <div className='col-auto header__menu'>

                        <nav className={`navigation ${ openMenu? 'opened':'' } `}>
                            <ul>
                                <li><NavLink to={`/${i18n.language}/`}>{t('header.homeLink')}</NavLink></li>
                                <li><NavLink to={`/${i18n.language}/models`}>{t('header.partsLink')}</NavLink></li>
                                {/*<li className='fog'><NavLink to={`/${i18n.language}/part-request`}>Part Request</NavLink></li>*/}
                                <li><NavLink to={`/${i18n.language}/cars/listing`}>{t('header.adsLink')}</NavLink></li>
                                <li><NavLink to={`/${i18n.language}/dismantlers`}>{t('header.dismantlersLink')}</NavLink></li>
                                <li><NavLink to={`/${i18n.language}/how-it-works`}>{t('header.howitworksLink')}</NavLink></li>
                            </ul>
                        </nav>

                    </div>
                    <div className='col-auto header__actions'>

                        <div className='row no-gutters align-items-center'>
                            <div className='col d-lg-none'><button className='btn btn-menu' onClick={toggleMenu}><Menu/></button></div>
                            <div className='col'><LanguageSelect/></div>
                            {
                                user.profile.isLogged ? (
                                    <>
                                        <div className='col'>
                                            <div className='nav-logout'>
                                                <div className='btn btn-login-mobile d-lg-none'><LogInBlack/></div>
                                                <div className='btn btn-secondary btn-icon btn-icon-left btn-login d-none d-lg-flex'><LogIn/>{ user.profile.fname && user.profile.fname != '' ? user.profile.fname : 'Profile'}</div>
                                                <div className='nav-logout__submenu'>
                                                    <div className='btn btn-primary btn-icon btn-icon-left btn-login mb-2' onClick={ () => { user.linkToDashBoard(); } }>{t('login.Dashboard')}</div>
                                                    <div className='btn btn-primary btn-icon btn-icon-left btn-login' onClick={logout}>{t('fields.logout')}</div>
                                                </div>
                                            </div>

                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className='col d-xl-none'><Link to={`/${i18n.language}/login`} className='btn btn-login-mobile'><LogInBlack/></Link></div>
                                        <div className='col d-none d-xl-block'><Link to={`/${i18n.language}/login`} className='btn btn-primary btn-icon btn-icon-left btn-login'><LogIn/>{t('fields.login')}</Link></div>
                                    </>
                                )
                            }

                            {/*<div className='col'><button className='btn btn-search' onClick={hundleSearchBox}><Search/></button></div>*/}
                        </div>

                    </div>
                </div>
            </div>

            <div className={`searchMain ${openSearch ? "opened" : ""}`}>
                <div className='searchMain__row'>
                    <div className='searchMain__elements'>
                        <div className='searchMain__elements-inner'>
                            <div className='row'>
                                <div className='col'>
                                    <select className='select-border'>
                                        <option>Select Make</option>
                                        <option>Select Make</option>
                                        <option>Select Make</option>
                                    </select>
                                </div>
                                <div className='col'>
                                    <select className='select-border'>
                                        <option>Select Model</option>
                                        <option>Select Model</option>
                                        <option>Select Model</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='searchMain__label'>
                        <div className='searchMain__label-inner' onClick={submitSearch}>{t('dismantlers.findAds')}</div>
                    </div>
                </div>
            </div>

        </header>
    );
};

export default Header;
